var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChatBubble = function SvgChatBubble(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      width: "100%",
      height: "auto",
      fill: "currentColor"
    },
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21a8.94 8.94 0 0 0 4.8-1.4L21 21l-1.4-4.2A8.994 8.994 0 1 0 12 21M8 8.5h8a1 1 0 0 1 0 2H8a1 1 0 0 1 0-2m0 5h4a1 1 0 0 1 0 2H8a1 1 0 0 1 0-2"
  })));
};
export default SvgChatBubble;